
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function RecorridoVirtual() {
    return (
        <div className='recorrido-360'>
            <div className='in'>

                <p className="titulo"><small>_</small> VISTA</p>
                <div className='tablet'>
                    <img
                        src={"/images/home/icono_3_tablet.svg"}
                        alt='icono 360'
                    />
                </div>

                <div className='note'>
                    <img
                        src={"/images/home/icono_3_escritorio.png"}
                        alt='icono 360'
                    />
                </div>

                <Link to="/recorre">
                    <Button variant="primary">
                        Explora
                    </Button>
                </Link>

                <p className="texto-small">VISITA TODOS SUS RINCONES</p>

            </div>
        </div>
    );
}